import axios from "axios";
import { buildTokenJWT, Encrypt, getOptions } from "./serviceEncrypt";
import { generateLegacyID } from "../utils/utils";

export async function getJsonOffersPorta() {
  const cacheName = "offers-cache";
  const cacheUrl = `${process.env.PUBLIC_URL}/data/offersDetailsPortaLN_v32.json`;

  // Comprueba si hay una versión en caché del archivo JSON
  const cache = await caches.open(cacheName);
  // const cachedResponse = await cache.match(cacheUrl);

  // if (cachedResponse) {
  // Si hay una versión en caché, devuélvela
  //   return cachedResponse.json();
  // }

  // Si no hay una versión en caché, realiza la solicitud y guarda el resultado en caché
  const response = await axios.get(cacheUrl);
  const responseData = response.data;
  cache.put(cacheUrl, new Response(JSON.stringify(responseData)));

  return responseData;
}

export async function getJsonShop() {
  const shopUrl = `${process.env.PUBLIC_URL}/data/ceActive_v1.json`;
  const response = await axios.get(shopUrl);
  const responseData = response.data;
  return responseData;
}

export async function postRequest(path, data) {
  let dateStamp = Date.now();
  let tokenJWT = await buildTokenJWT(dateStamp);
  let options = await getOptions(tokenJWT);
  return axios.post(
    `${process.env.REACT_APP_CAPTACION}/${path}`,
    data,
    options
  );
}

export async function servicePost(data, path) {
  let dataEncrypt = Encrypt(data);
  return await postRequest(path, dataEncrypt);
}

export async function servicePostSession(serviceRequest, SessionID, path) {
  let dataEncrypt = Encrypt(serviceRequest);
  let data = JSON.stringify({
    serviceNumber: dataEncrypt,
    sessionID: SessionID,
  });
  return await postRequest(path, data);
}

export async function customerInfoById(dataPage, path, SessionID) {
  let data = JSON.stringify({
    IdType: Encrypt(dataPage.idType),
    ServiceNumber: Encrypt(dataPage.idNumber),
    SessionID: SessionID,
  });
  return await postRequest(path, data);
}
export async function stockReservation(data, path) {
  let fullstackOrderNumberEncrypt = Encrypt(data.fullstackOrderNumber);
  let warehouseIdEncrypt = Encrypt(data.warehouseId);
  let materialNumberEncrypt = Encrypt(data.materialNumber);
  let dataToSend = {
    fullstackOrderNumber: fullstackOrderNumberEncrypt,
    warehouseId: warehouseIdEncrypt,
    materialNumber: materialNumberEncrypt,
    sessionID: data.sessionID,
  };
  return await postRequest(path, dataToSend);
}

export async function verifyAddressService(
  departmentBizCode,
  cityBizCode,
  street,
  complement,
  completeAddress,
  SessionID,
  path
) {
  let departmentBizCodeEncrypt = Encrypt(departmentBizCode);
  let cityBizCodeEncrypt = Encrypt(cityBizCode);
  let fullAddress = completeAddress
    ? completeAddress
    : `${street} ${complement}`;
  let fullAddressEncrypt = Encrypt(fullAddress);
  let data = JSON.stringify({
    StateOrProvinceGeographicAddress: departmentBizCodeEncrypt,
    TownIdGeographicAddress: cityBizCodeEncrypt,
    FormattedRespAddressSubsidy: fullAddressEncrypt,
    SessionID: SessionID,
  });
  return await postRequest(path, data);
}

export async function logisticArrivalTimeService(
  departmentRegionCode,
  municipalityRegionCode,
  SessionID,
  path
) {
  let departmentRegionCodeEncrypt = Encrypt(departmentRegionCode);
  let municipalityRegionCodeEncrypt = Encrypt(municipalityRegionCode);
  let deliveryTypeEncrypt = Encrypt("Normal");
  let data = JSON.stringify({
    DePartment: departmentRegionCodeEncrypt,
    MuniCipality: municipalityRegionCodeEncrypt,
    DeliveryType: deliveryTypeEncrypt,
    SessionID: SessionID,
  });
  return await postRequest(path, data);
}

export async function validatePCOService(dataPage, path, SessionID) {
  const offer = {
    offerId: Encrypt(dataPage.idOffer),
    offerName: Encrypt(dataPage.offerName),
    offerPrice: Encrypt(dataPage.offerPrice),
  };

  const user = {
    idType: Encrypt(dataPage.idType),
    idNumber: Encrypt(dataPage.idNumber),
    effectiveTime: Encrypt(dataPage.effectiveTime),
    lastName: Encrypt(dataPage.lastName),
    birthday: Encrypt(dataPage.birthday),
  };

  const commonData = {
    offer,
    user,
    legacyID: generateLegacyID(),
    SessionID: SessionID,
  };

  const data = JSON.stringify({ ...commonData });

  return await postRequest(path, data);
}

export async function wareHouseListNService(busiList, sessionID, path) {
  return await postRequest(path, {
    busiHallIds: busiList,
    SessionID: sessionID,
  });
}

export async function inventoryStockService(wareHouseIds, sessionID, skuCode, path) {
  let simSkuCodeEncrypt = Encrypt(skuCode);
  let data = JSON.stringify({
    warehouseIds: wareHouseIds,
    simSkuCode: simSkuCodeEncrypt,
    SessionID: sessionID,
  });
  return await postRequest(path, data);
}

export async function regionListService(regionId, SessionID, path) {
  let regionIdEncrypt = Encrypt(regionId);
  let data = JSON.stringify({
    regionId: regionIdEncrypt,
    SessionID: SessionID,
  });
 
  let dateStamp = Date.now();
  let tokenJWT = await buildTokenJWT(dateStamp);
  let options = await getOptions(tokenJWT);
  return axios.post(
    `https://prepago.movistar.co/captacion-back/${path}`,
    data,
    options
  );
}

export async function createOrderService(createOrderRequest, path) {
  createOrderRequest.offerId = Encrypt(createOrderRequest.offerId);
  createOrderRequest.user.homeAddress.addr9 = Encrypt(
    createOrderRequest.user.homeAddress.addr9
  );
  return await postRequest(path, createOrderRequest);
}

export async function createAbandonedCartService(createAbandonedCartRequest, path) {
  const paymentDataString = JSON.stringify(createAbandonedCartRequest.cartData.paymentData);
  createAbandonedCartRequest.cartData.invoice = Encrypt(createAbandonedCartRequest.cartData.invoice);
  createAbandonedCartRequest.cartData.paymentData = Encrypt(paymentDataString);
  createAbandonedCartRequest.cartData.orderNumber = Encrypt(createAbandonedCartRequest.cartData.orderNumber);
  createAbandonedCartRequest.cartData.lineNumber = Encrypt(createAbandonedCartRequest.cartData.lineNumber);
  createAbandonedCartRequest.cartData.purchaseType = Encrypt(createAbandonedCartRequest.cartData.purchaseType);
  createAbandonedCartRequest.cartData.simType = Encrypt(createAbandonedCartRequest.cartData.simType);
  return await postRequest(path, createAbandonedCartRequest);
}

/**
 * Servicio datos para homologacion de los canales , extra2 a extra5
 */
export async function getJsonHomologation() {
  return await axios.get(`${process.env.PUBLIC_URL}/data/homologation.json`);
}

// Servicio que consulta el estado de la transacción en ePayco
export async function getPaymentValidation(refEpayco) {
  try {
    const response = await fetch(
      `https://secure.epayco.co/validation/v1/reference/` + refEpayco
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al consultar la transacción:", error);
    return { success: false, error: error.message };
  }
}

//Metodos a quitar en confirmation setEsim y qRThalesService
export async function setEsim(
  iccid,
  order,
  sessionID,
  EsimStoreRequest
) {
  const requestData = {
    Iccid: Encrypt(iccid), // Encriptación del ICCID
    Order: Encrypt(order), // Encriptación del order
    SessionID: sessionID, // SessionID sin encriptar
    EsimStoreRequest
  };
  const data = JSON.stringify(requestData);
  return await postRequest("esim/setEsim", data);
}
/**
 * Servicio para traer QR thales
 */
export async function qRThalesService(
  iccid,
  order,
  sessionID,
  receiver,
  receiverName,
  portaDate,
  offerPrice,
  offerDescription,
  refEpayco,
  EsimStoreRequest
) {
  let receiverEncrypt = Encrypt(receiver);
  let receiverNameEncrypt = Encrypt(receiverName);
  let portaDateEncrypt = Encrypt(portaDate);
  let refEpaycoEncrypt = Encrypt(refEpayco);
  let SendEmailWithQRFront = {
    Receiver: receiverEncrypt,
    ReceiverName: receiverNameEncrypt,
    PortaDate: portaDateEncrypt,
    OfferPrice: offerPrice,
    offerDescription: offerDescription,
    RefEpayco: refEpaycoEncrypt,
  };
  EsimStoreRequest.status = Encrypt(EsimStoreRequest.status);
  EsimStoreRequest.phonenumber = Encrypt(EsimStoreRequest.phonenumber);
  EsimStoreRequest.userdocument = Encrypt(EsimStoreRequest.userdocument);
  EsimStoreRequest.orderNum = Encrypt(EsimStoreRequest.orderNum);
  const requestData = {
    Iccid: Encrypt(iccid), // Encriptación del ICCID
    Order: Encrypt(order), // Encriptación del order
    SessionID: sessionID, // SessionID sin encriptar
    SendEmailWithQRFront,
    EsimStoreRequest
  };
  const data = JSON.stringify(requestData);
  return await postRequest("esim/activateEsim", data);
}